











import { Vue, Component } from 'vue-property-decorator';
const tagAndTagSpacing = 4; // tagAndTagSpacing

// 因为是el-elment 是隐藏属性，所以没法办法改成强类型
@Component
export default class ScrollPane extends Vue {

  public get scrollWrapper(): any {
    const elScrollbar = this.$refs.scrollContainer  as any;
    return elScrollbar.$refs.wrap;
  }
  public left: number = 0;

  public moveToTarget(currentTag: any) {
    const $elScrollbar = this.$refs.scrollContainer  as any;
    const $container =  $elScrollbar.$el;
    const $containerWidth = $container.offsetWidth;
    const $scrollWrapper = this.scrollWrapper;
    const tagList = this.$parent.$refs.tag as any;

    let firstTag = null;
    let lastTag = null;

    // find first tag and last tag
    if (tagList.length > 0) {
      firstTag = tagList[0];
      lastTag = tagList[tagList.length - 1];
    }

    if (firstTag === currentTag) {
      $scrollWrapper.scrollLeft = 0;
    } else if (lastTag === currentTag) {
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth;
    } else {
      // find preTag and nextTag
      const currentIndex = tagList.findIndex((item: any) => item === currentTag);
      const prevTag = tagList[currentIndex - 1];
      const nextTag = tagList[currentIndex + 1];

      // the tag's offsetLeft after of nextTag
      const afterNextTagOffsetLeft =
        nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing;

      // the tag's offsetLeft before of prevTag
      const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagAndTagSpacing;

      if (
        afterNextTagOffsetLeft >
        $scrollWrapper.scrollLeft + $containerWidth
      ) {
        $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth;
      } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
        $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft;
      }
    }
  }

  /**
   * name
   */
  private handleScroll(e: any) {
    const eventDelta = e.wheelDelta || -e.deltaY * 40;
    const $scrollWrapper = this.scrollWrapper;
    $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4;
  }
}
